export enum TabsTypes {
    "Tab",
    "TabList",
    "TabPanel"
}